import { useState, useEffect } from "react";
import { ActionFunctionArgs, Form, useActionData, useNavigate } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { myAxios } from "src/components/common/functions";
import Notification from "src/components/common/Notification";
import logo from "src/img/logo.png";
import { Link } from "react-router-dom";
import { useModalStore } from "../main/modalStore";

export default function ForgetPassword(){
    //--------------------------------------------------------------------------------------------
    const defaultNotification: {
        show: boolean, 
        title?: string, 
        msg?: string, 
        callBack?: Function, 
        preventClose?: boolean
    } = { 
        show: false, 
        title: "", 
        msg: ""
    };
    const [notification, setNotification] = useState(defaultNotification);
    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const actionData = useActionData();
    const navigate = useNavigate();
    useEffect(() => {
        if (!actionData) return;
        if (actionData.ok === false) {
             useModalStore.getState().showModal({
                title: actionData.title,
                message: actionData.msg,
            });
        }
        useModalStore.getState().showModal({
            title: actionData.title,
            message: actionData.msg,
            onConfirm: () => navigate("/Login", { replace: true })
        });
    }, [actionData, navigate]);
    //--------------------------------------------------------------------------------------------
    return (
        <div className = "loginBox">
            <img className = "cssLoginLogo" src = {logo} alt = ""/>               
            <Form method = "post">
                <input className = "bwinput" type = "email" placeholder = "Email" id = "email" name = "email" value = {email} onChange = {(e) => setEmail(e.currentTarget.value.toLowerCase())} required autoComplete = "off"/>
                <button type = "submit" className = "bwbtn">SEND PASSWORD</button>
                <Link className = "bwbtn text-decoration-none" to = "/Login">GO BACK</Link>
            </Form>
            {notification.show?
            <Notification
                title = {notification.title || ""}
                msg = {notification.msg || ""}
                closeIt = {notification.preventClose ?
                () => {} :
                (notification.callBack ?
                    notification.callBack :
                    () => setNotification({ show : false })
                )}
            />:null}
        </div>
    );
}

export async function forgetPasswordAction({ request }:ActionFunctionArgs ){
    const formData = await request.formData();
    const email = formData.get("email");
    if (!email) {
        return {
            ok: false,
            title: "Error",
            msg: "Email is required",
        };
    }
    const res = await myAxios({ fileName: "auth/forgetPassword.php", formData: formData });
    if(!res) return;
    return res.data;
}